import React from 'react';

import Typography from 'components/uiLibrary/Typography';

import CommonTrans from 'components/Globals/CommonTrans';

import { TP } from 'constants/index';

const PriceRange = ({ price, isMonthly = false, priceSize = 22 }) => {
  if (!price) {
    return null;
  }

  if (price === '€0') {
    return (
      <Typography color="orange" size={priceSize} weight="bold">
        {price}
      </Typography>
    );
  }

  return (
    <Typography size={10} variant="p" color="secondary">
      <CommonTrans
        ns="NS_APP_GLOBALS"
        i18nKey={isMonthly ? `${TP}.FN_PRICE_PER_MONTH` : `${TP}.FN_PRICE_PER_YEAR`}
        components={{ price: <Typography color="orange" size={priceSize} weight="bold" /> }}
        values={{
          price,
        }}
      />
    </Typography>
  );
};

export default PriceRange;
